import { render, staticRenderFns } from "./MemberDetail.vue?vue&type=template&id=47c39f66&scoped=true"
import script from "./MemberDetail.vue?vue&type=script&lang=js"
export * from "./MemberDetail.vue?vue&type=script&lang=js"
import style0 from "./MemberDetail.vue?vue&type=style&index=0&id=47c39f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c39f66",
  null
  
)

export default component.exports